import React from 'react';
import { TextAreaField, type TextAreaFieldProps } from '~/shared/forms/controls/base-fields/TextAreaField';
import { useFormField } from '../../../useFormField';
import type { StripControlledProperties } from '../../../types';

export function TextAreaFormField(props: StripControlledProperties<TextAreaFieldProps>) {
	const fieldProps = useFormField<string | null>(props);
	return <TextAreaField {...props} {...fieldProps} value={fieldProps.value ?? ''} />;
}
